
import { createRouter, createWebHashHistory } from 'vue-router';

export default async ({ store }) => {
	let routes = [
		//Dashboard routes

		//applicants routes
		{
			path: '/applicants',
			alias: '/applicants/:fieldName/:fieldValue',
			name: 'applicantslist',
			component: () => import('./pages/applicants/list.vue'),
			props: true
		},


		{
			path: '/applicants/view/:id',
			name: 'applicantsview',
			component: () => import('./pages/applicants/view.vue'),
			props: true
		},

		{
			path: '/applicants/edit/:id',
			name: 'applicantsedit',
			component: () => import('./pages/applicants/edit.vue'),
			props: true
		},

		{
			path: '/applicants/admissions',
			alias: '/applicants/admissions/:fieldName/:fieldValue',
			name: 'applicantsadmissions',
			component: () => import('./pages/applicants/admissions.vue'),
			props: true
		},

		{
			path: '/applicants/confirmed_admissions',
			alias: '/applicants/confirmed_admissions/:fieldName/:fieldValue',
			name: 'applicantsconfirmed_admissions',
			component: () => import('./pages/applicants/confirmed_admissions.vue'),
			props: true
		},


		{
			path: '/applicants/capsmall',
			alias: '/applicants/capsmall/:fieldName/:fieldValue',
			name: 'applicantscapsmall',
			component: () => import('./pages/applicants/capsmall.vue'),
			props: true
		},

		{
			path: '/applicants/capsmall_applications',
			alias: '/applicants/capsmall_applications/:fieldName/:fieldValue',
			name: 'applicantscapsmall_applications',
			component: () => import('./pages/applicants/capsmall_applications.vue'),
			props: true
		},


		//caps_institutions_list routes
		{
			path: '/caps_institutions_list',
			alias: '/caps_institutions_list/:fieldName/:fieldValue',
			name: 'caps_institutions_listlist',
			component: () => import('./pages/caps_institutions_list/list.vue'),
			props: true
		},


		{
			path: '/caps_institutions_list/view/:id',
			name: 'caps_institutions_listview',
			component: () => import('./pages/caps_institutions_list/view.vue'),
			props: true
		},

		{
			path: '/caps_institutions_list/edit',
			name: 'caps_institutions_listedit',
			component: () => import('./pages/caps_institutions_list/edit.vue'),
			props: true
		},


		//caps_mall_activities routes
		{
			path: '/caps_mall_activities',
			alias: '/caps_mall_activities/:fieldName/:fieldValue',
			name: 'caps_mall_activitieslist',
			component: () => import('./pages/caps_mall_activities/list.vue'),
			props: true
		},


		{
			path: '/caps_mall_activities/view/:id',
			name: 'caps_mall_activitiesview',
			component: () => import('./pages/caps_mall_activities/view.vue'),
			props: true
		},

		{
			path: '/caps_mall_activities/add',
			name: 'caps_mall_activitiesadd',
			component: () => import('./pages/caps_mall_activities/add.vue'),
			props: true
		},

		{
			path: '/caps_mall_activities/edit/:id',
			name: 'caps_mall_activitiesedit',
			component: () => import('./pages/caps_mall_activities/edit.vue'),
			props: true
		},


		//caps_programmes_list routes
		{
			path: '/caps_programmes_list',
			alias: '/caps_programmes_list/:fieldName/:fieldValue',
			name: 'caps_programmes_listlist',
			component: () => import('./pages/caps_programmes_list/list.vue'),
			props: true
		},


		{
			path: '/caps_programmes_list/view/:id',
			name: 'caps_programmes_listview',
			component: () => import('./pages/caps_programmes_list/view.vue'),
			props: true
		},

		{
			path: '/caps_programmes_list/add',
			name: 'caps_programmes_listadd',
			component: () => import('./pages/caps_programmes_list/add.vue'),
			props: true
		},

		{
			path: '/caps_programmes_list/edit/:id',
			name: 'caps_programmes_listedit',
			component: () => import('./pages/caps_programmes_list/edit.vue'),
			props: true
		},

		//institution_account_permissions routes
		{
			path: '/institution_account_permissions',
			alias: '/institution_account_permissions/:fieldName/:fieldValue',
			name: 'institution_account_permissionslist',
			component: () => import('./pages/institution_account_permissions/list.vue'),
			props: true
		},


		{
			path: '/institution_account_permissions/view/:id',
			name: 'institution_account_permissionsview',
			component: () => import('./pages/institution_account_permissions/view.vue'),
			props: true
		},

		{
			path: '/institution_account_permissions/add',
			name: 'institution_account_permissionsadd',
			component: () => import('./pages/institution_account_permissions/add.vue'),
			props: true
		},

		{
			path: '/institution_account_permissions/edit/:id',
			name: 'institution_account_permissionsedit',
			component: () => import('./pages/institution_account_permissions/edit.vue'),
			props: true
		},


		//institution_account_roles routes
		{
			path: '/institution_account_roles',
			alias: '/institution_account_roles/:fieldName/:fieldValue',
			name: 'institution_account_roleslist',
			component: () => import('./pages/institution_account_roles/list.vue'),
			props: true
		},


		{
			path: '/institution_account_roles/view/:id',
			name: 'institution_account_rolesview',
			component: () => import('./pages/institution_account_roles/view.vue'),
			props: true
		},

		{
			path: '/institution_account_roles/add',
			name: 'institution_account_rolesadd',
			component: () => import('./pages/institution_account_roles/add.vue'),
			props: true
		},

		{
			path: '/institution_account_roles/edit/:id',
			name: 'institution_account_rolesedit',
			component: () => import('./pages/institution_account_roles/edit.vue'),
			props: true
		},


		//institution_accounts routes
		{
			path: '/institution_accounts',
			alias: '/institution_accounts/:fieldName/:fieldValue',
			name: 'institution_accountslist',
			component: () => import('./pages/institution_accounts/list.vue'),
			props: true
		},
		{
			path: '/institution_accounts/view/:id',
			name: 'institution_accountsview',
			component: () => import('./pages/institution_accounts/view.vue'),
			props: true
		},
		{
			path: '/institution_accounts/resetpassword/:id',
			name: 'institution_accountsresetpassword',
			component: () => import('./pages/institution_accounts/resetpassword.vue'),
			props: true
		},
		
		{
			path: '/account/edit',
			name: 'institution_accountsaccountedit',
			component: () => import('./pages/account/accountedit.vue'),
			props: true
		},

		{
			path: '/account',
			name: 'institution_accountsaccountview',
			component: () => import('./pages/account/accountview.vue'),
			props: true
		},

		{
			path: '/institution_accounts/add',
			name: 'institution_accountsadd',
			component: () => import('./pages/institution_accounts/add.vue'),
			props: true
		},

		{
			path: '/institution_accounts/edit/:id',
			name: 'institution_accountsedit',
			component: () => import('./pages/institution_accounts/edit.vue'),
			props: true
		},


		//institution_admissions_uploads routes
		{
			path: '/institution_admissions_uploads',
			alias: '/institution_admissions_uploads/:fieldName/:fieldValue',
			name: 'institution_admissions_uploadslist',
			component: () => import('./pages/institution_admissions_uploads/list.vue'),
			props: true
		},


		{
			path: '/institution_admissions_uploads/view/:id',
			name: 'institution_admissions_uploadsview',
			component: () => import('./pages/institution_admissions_uploads/view.vue'),
			props: true
		},

		{
			path: '/institution_admissions_uploads/add',
			name: 'institution_admissions_uploadsadd',
			component: () => import('./pages/institution_admissions_uploads/add.vue'),
			props: true
		},


		//institution_campuses routes
		{
			path: '/institution_campuses',
			alias: '/institution_campuses/:fieldName/:fieldValue',
			name: 'institution_campuseslist',
			component: () => import('./pages/institution_campuses/list.vue'),
			props: true
		},


		{
			path: '/institution_campuses/view/:id',
			name: 'institution_campusesview',
			component: () => import('./pages/institution_campuses/view.vue'),
			props: true
		},

		{
			path: '/institution_campuses/add',
			name: 'institution_campusesadd',
			component: () => import('./pages/institution_campuses/add.vue'),
			props: true
		},

		{
			path: '/institution_campuses/edit/:id',
			name: 'institution_campusesedit',
			component: () => import('./pages/institution_campuses/edit.vue'),
			props: true
		},


		//institution_programmes routes
		{
			path: '/institution_programmes',
			alias: '/institution_programmes/:fieldName/:fieldValue',
			name: 'institution_programmeslist',
			component: () => import('./pages/institution_programmes/list.vue'),
			props: true
		},


		{
			path: '/institution_programmes/view/:id',
			name: 'institution_programmesview',
			component: () => import('./pages/institution_programmes/view.vue'),
			props: true
		},

		{
			path: '/institution_programmes/add',
			name: 'institution_programmesadd',
			component: () => import('./pages/institution_programmes/add.vue'),
			props: true
		},

		{
			path: '/institution_programmes/edit/:id',
			name: 'institution_programmesedit',
			component: () => import('./pages/institution_programmes/edit.vue'),
			props: true
		},


		//institution_schools routes
		{
			path: '/institution_schools',
			alias: '/institution_schools/:fieldName/:fieldValue',
			name: 'institution_schoolslist',
			component: () => import('./pages/institution_schools/list.vue'),
			props: true
		},


		{
			path: '/institution_schools/view/:id',
			name: 'institution_schoolsview',
			component: () => import('./pages/institution_schools/view.vue'),
			props: true
		},

		{
			path: '/institution_schools/add',
			name: 'institution_schoolsadd',
			component: () => import('./pages/institution_schools/add.vue'),
			props: true
		},

		{
			path: '/institution_schools/edit/:id',
			name: 'institution_schoolsedit',
			component: () => import('./pages/institution_schools/edit.vue'),
			props: true
		},


		//payments routes
		{
			path: '/payments',
			alias: '/payments/:fieldName/:fieldValue',
			name: 'paymentslist',
			component: () => import('./pages/payments/list.vue'),
			props: true
		},

		//waec_results routes
		{
			path: '/waec_results/view/:id',
			name: 'waec_resultsview',
			component: () => import('./pages/waec_results/view.vue'),
			props: true
		},

		//custom routes

		{
			path: '/capsoverview',
			name: 'capsoverview',
			component: () => import('././pages/custom/capsoverview.vue'),
			props: true
		},

		{
			path: '/help',
			name: 'help',
			component: () => import('././pages/custom/help.vue'),
			props: true
		},


		//Otp verify code routes
		{
			path: '/index/verifyotp',
			name: 'verifyotp',
			component: () => import('./pages/index/verifyotp.vue'),
			props: true
		},


		//Password reset routes
		{
			path: '/index/forgotpassword',
			name: 'forgotpassword',
			component: () => import('./pages/index/forgotpassword.vue'),
			props: true
		},
		{
			path: '/index/resetpassword',
			name: 'resetpassword',
			component: () => import('./pages/index/resetpassword.vue'),
			props: true
		},
		{
			path: '/index/resetpassword_completed',
			name: 'resetpassword_completed',
			component: () => import('./pages/index/resetpassword_completed.vue'),
			props: true
		},


		//Email verify routes
		{
			path: '/index/verifyemail',
			name: 'verifyemail',
			component: () => import('./pages/index/verifyemail.vue'),
			props: true
		},
		{
			path: '/index/emailverified',
			name: 'emailverified',
			component: () => import('./pages/index/emailverified.vue'),
			props: true
		},


		{
			path: '/index/accountcreated',
			name: 'accountcreated',
			component: () => import('./pages/index/accountcreated.vue'),
			props: true
		},
		{
			path: '/index/accountinactive',
			name: 'accountinactive',
			component: () => import('./pages/index/accountinactive.vue'),
			props: true
		},
		{
			path: '/index/accountpending',
			name: 'accountpending',
			component: () => import('./pages/index/accountpending.vue'),
			props: true
		},
		{
			path: '/index/accountblocked',
			name: 'accountblocked',
			component: () => import('./pages/index/accountblocked.vue'),
			props: true
		},

		{
			path: '/error/forbidden',
			name: 'forbidden',
			component: () => import('./pages/errors/forbidden.vue'),
			props: true
		},
		{
			path: '/error/notfound',
			name: 'notfound',
			component: () => import('./pages/errors/pagenotfound.vue'),
			props: true
		},
		{
			path: '/:catchAll(.*)',
			component: () => import('./pages/errors/pagenotfound.vue')
		}
	];


	let loginToken = store.getters["auth/getLoginToken"];
	if (loginToken) {	//Token is available, user might still be logged in
		try {
			//fetch user data for the first time and saves in the vuex store
			await store.dispatch("auth/getUserData");
		}
		catch (e) {
			store.dispatch("auth/logout"); //token must have expired
		}
	}


	let user = store.state.auth.user;
	if (user) {
		routes.push({
			path: '/',
			alias: '/home',
			name: 'home',
			component: () => import(`./pages/home/home.vue`),
			props: true
		});
	}
	else {
		routes.push({
			path: '/',
			alias: '/index',
			name: 'index',
			component: () => import('./pages/index/index.vue'),
			props: true
		});
	}


	const router = createRouter({
		history: createWebHashHistory(),
		routes,
	});

	router.beforeEach(function (to, from, next) {
		window.scrollTo(0, 0);
		next();
	});

	return router;
}
